import React, { useEffect, useMemo, useRef } from "react";


const formatPayload = value => {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return "";
    try {
      return JSON.stringify(JSON.parse(trimmed), null, 2);
    } catch (e) {
      return trimmed;
    }
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch (e) {
    return String(value);
  }
};

const VUApiHistoryDetailsModal = ({ item, onClose }) => {
  const cardRef = useRef(null);
  const previouslyFocused = useRef(null);

  useEffect(() => {
    previouslyFocused.current = document.activeElement;
    const focusable = cardRef.current?.querySelector(
      "button, [href], input, textarea",
    );
    if (focusable) focusable.focus();

    const onKey = e => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.classList.add("api-key-manager-dialog-open");

    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.classList.remove("api-key-manager-dialog-open");
      if (previouslyFocused.current && previouslyFocused.current.focus) {
        previouslyFocused.current.focus();
      }
    };
  }, [onClose]);

  const requestBodyText = useMemo(
    () => formatPayload(item.requestBody),
    [item.requestBody],
  );
  const responseBodyText = useMemo(
    () => formatPayload(item.responseData),
    [item.responseData],
  );
  const hasError =
    item.isSuccess === false ||
    (typeof item.errorMessage === "string" && item.errorMessage.length > 0);

  return (
    <div className="api-key-manager-dialog-backdrop" role="presentation">
      <div
        ref={cardRef}
        className="api-key-manager-dialog api-key-manager-dialog--lg vu-api-history-details"
        role="dialog"
        aria-modal="true"
        aria-labelledby="vu-api-history-details-title"
      >
        <div className="api-key-manager-dialog__header">
          <div
            id="vu-api-history-details-title"
            className="api-key-manager-dialog__title"
            role="heading"
            aria-level={2}
          >
            Request Details
          </div>
        </div>

        <div className="api-key-manager-dialog__body">
          {hasError ? (
            <div
              className="api-key-manager-dialog__error"
              role="alert"
            >
              {item.errorMessage ||
                "The request did not complete successfully."}
            </div>
          ) : null}

          {requestBodyText ? (
            <section className="vu-api-history-details__section">
              <div className="vu-api-history-details__section-title">
                Request Body
              </div>
              <pre className="api-key-manager-dialog__code vu-api-history-details__pre">
                {requestBodyText}
              </pre>
            </section>
          ) : null}

          <section className="vu-api-history-details__section">
            <div className="vu-api-history-details__section-title">
              Response Data
            </div>
            {responseBodyText ? (
              <pre className="api-key-manager-dialog__code vu-api-history-details__pre">
                {responseBodyText}
              </pre>
            ) : (
              <p className="api-key-manager-dialog__muted">
                No response data was recorded for this request.
              </p>
            )}
          </section>

          <div className="api-key-manager-dialog__actions">
            <button
              type="button"
              className="btn btn--primary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VUApiHistoryDetailsModal;
